<div class="sbnb-toast-container" [class.hidden]="hideToasts">
  <sbnb-toast *ngFor="let message of messages | async" [message]="message" (onHide)="hideToast($event)"></sbnb-toast>
</div>
